import React, { Component } from "react";

export default class AddressImg extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <svg
        id="address-illustration"
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 747.137 880"
      >
        <title>Address</title>
        <g transform="translate(-813.179 -232.225)">
          <g transform="translate(870.201 256.381)">
            <path
              d="M310.564,488.656s43.733-20.9,43.034-2.85-44.083,29.918-44.083,29.918Z"
              transform="translate(-51.701 -241.566)"
              fill="#ffb8b8"
            />
            <path
              d="M378.331,579.064s20.626,50.5,28.255,86.943,19.233,86.591,4.3,122.159-57.393,140.093-57.829,151.377,3.636,22.732-5.383,22.381-58.124-15.808-60.117-22.664,16.752-24.2,16.752-24.2L350.6,770.007,302.3,675.51,267.468,816.483,260.645,992.43s-33.486-10.34-38.346-1.487c0,0-15-20.913-16.909-30.03S212.472,778.2,212.472,778.2s-30.738-197.735-5.924-196.773S328.549,522.915,378.331,579.064Z"
              transform="translate(-143.457 -179.287)"
              fill={theme.text}
            />
            <path
              d="M311.542,781.21S334.43,831.8,336.6,834.141s17.083,25.513,5.808,25.072-37.91-12.766-57.51-31.6-45.446-51.463-43.1-53.631,18.4-8.323,18.4-8.323Z"
              transform="translate(-106.978 -7.594)"
              fill={theme.text}
            />
            <path
              d="M249.136,791.541s1.381,22.644,5.543,31.842,3.636,22.732-7.642,22.295-40.427-.4-40.427-.4-1.731-13.621.612-15.79,12.324-32.315,8.074-39.257S249.136,791.541,249.136,791.541Z"
              transform="translate(-136.026 10.156)"
              fill={theme.text}
            />
            <path
              d="M236.474,384.75S212.43,422.222,203.057,430.9s17,27.764,17,27.764l47.2,6.349s-.594-42.946,1.841-47.37S236.474,384.75,236.474,384.75Z"
              transform="translate(-140.05 -317.913)"
              fill="#ffb8b8"
            />
            <path
              d="M284.432,413.912s-9.723,17.7-18.746,17.347-45.116-14.621-47.109-21.476-26.036,43.487-26.036,43.487l114.2,200.972L334.6,634.99l-13.5-118-11.086-63.685Z"
              transform="translate(-146.987 -298.042)"
              fill={theme.secondaryText}
            />
            <path
              d="M124.677,334.719c-69.138-23.013-48.664-26.736-66.535-31.949-7.371-2.16-7.94-11.354-5.937-23.949.581-3.7,1.38-7.691,2.292-11.882-16.776-15.788-34.869-34.17-43.084-40.53C-3.944,214.516,2.142,174.088.08,110.756c-1.293-39.774,13.276-52.2,24.3-55.948C34.157,39.165,48.188,25.2,53.055,13.082c12.5-31.143,44.544,2.106,38.876,9.7C86.659,29.833,79.3,20.4,78.3,19.058c2.09,2.866,32.583,44.662,47.148,62.674,15.09,18.657,38.068,66.989,38.068,66.989l3.3-26.983L147.067,48.68,127.135,18.735l.12-6.939c6.084-3.854,14.508-9.692,21.56-8.228,11.19,2.692,19.513,21.09,19.513,21.09l14.4,93.736,33.544,9.781L265.9,130.1l5.1,43.124-73.5,5.3c9.38,16.5,24.162,43.806,23.863,51.517-.438,11.28,20.282,59.526,20.282,59.526s8.148,22.908-1.046,27.068c-4.739,2.138-15.1-4.917-24.364-11.973-8.735-6.651-16.487-13.3-17.622-12.25-2.344,2.167,7.623,36.439,7.448,40.953-.112,2.918-5.2,12.266-27.516,12.266C166.373,345.622,149.076,342.841,124.677,334.719ZM53.5,189.634c-.1,2.653,3.447,6.815,8.961,11.558A63.159,63.159,0,0,0,56.8,185.245q-.923-1.927-1.937-3.83A51.13,51.13,0,0,0,53.5,189.634Z"
              transform="translate(0 110.485)"
              fill={theme.secondaryText}
            />
            <path
              d="M242.153,553.589s47.816,7.932,36.9,22.321-53.272-.738-53.272-.738Z"
              transform="translate(-119.905 -180.365)"
              fill="#ffb8b8"
            />
            <circle
              cx="49.663"
              cy="49.663"
              r="49.663"
              transform="translate(80.422 22.998)"
              fill="#ffb8b8"
            />
            <path
              d="M298.026,353.235a9.59,9.59,0,0,0,4.176,2.1,2.975,2.975,0,0,0,3.453-2.392,12.382,12.382,0,0,0,4.738,6.077c2.32,1.21,5.907.2,6.241-2.4a10.949,10.949,0,0,0,2.52,5.319,3.775,3.775,0,0,0,5.306.177c-1.016,5.553-.39,11.261-.708,16.9s-1.822,11.615-6.08,15.315c-6.209,5.4-15.546,4.07-23.714,3.047a7.2,7.2,0,0,0-3.716.2c-3.058,1.3-2.919,5.56-2.96,8.884a24.684,24.684,0,0,1-21.615,23.44,12.375,12.375,0,0,1-9.2-2.244c-2.319-1.966-3.5-5.169-6.16-6.646-4.322-2.408-9.564,1.1-12.725,4.9s-6.275,8.482-11.171,9.178c-6.475.921-11.406-5.677-13.827-11.757a68.52,68.52,0,0,1,1.361-53.241C227.471,340.627,273.655,335.972,298.026,353.235Z"
              transform="translate(-136.077 -343.208)"
              fill={theme.text}
            />
          </g>
          <path
            d="M175,710.234c0-1,.223-1.815.5-1.815h423.69c.276,0,.5.813.5,1.815s-.223,1.815-.5,1.815H175.5C175.223,712.054,175,711.241,175,710.234Z"
            transform="translate(638.179 400.177)"
            fill={theme.secondaryText}
          />
          <g transform="translate(1150.984 232.225)">
            <g transform="translate(0 0)">
              <path
                d="M8.186,0H401.145a8.186,8.186,0,0,1,8.186,8.186V237.412a8.186,8.186,0,0,1-8.186,8.186H24.646l-11.9,22.716-7.69,9.126C.54,277.441,0,241.934,0,237.412V8.186A8.186,8.186,0,0,1,8.186,0Z"
                transform="translate(0 0)"
                fill={theme.dark}
              />
              <path
                d="M8.107,0H397.136a8.085,8.085,0,0,1,8.105,8.066V233.913a8.085,8.085,0,0,1-8.105,8.066l-376.067-.157-10.987,21.6-6.619,8.839C-1.014,272.259,0,238.368,0,233.913V8.066A8.085,8.085,0,0,1,8.107,0Z"
                transform="translate(2.044 2.046)"
                fill={theme.secondaryText}
              />
            </g>
            <g transform="translate(31.536 53.907)">
              <path
                d="M370.042,296.985H206.02a8.337,8.337,0,0,1-8.327-8.327V169.05a8.337,8.337,0,0,1,8.327-8.327H370.042a8.337,8.337,0,0,1,8.327,8.327V288.658A8.337,8.337,0,0,1,370.042,296.985Z"
                transform="translate(-197.693 -160.723)"
                fill={theme.imageHighlight}
              />
              <path
                d="M47.954,136.266V29.955H0V28.947H47.954V0h1.011V28.947h57.446l0,0L92.041,0h1.129l14.364,28.944v0h72.635v1.008H108.042l21.223,42.763v0h50.9v1.012h-50.4l12.85,25.874,17.939,36.154H159.43l-17.382-35.015H48.965v35.521Zm93.59-36.532-12.852-25.9L106.909,29.955H48.965V99.734Z"
                transform="translate(0.252 0.25)"
                fill={theme.body}
              />
              <path
                d="M373.048,247.9c0,8.6-12.651,32.862-17.4,41.67a2.016,2.016,0,0,1-3.55,0c-4.752-8.808-17.4-33.067-17.4-41.67a19.178,19.178,0,1,1,38.356,0Z"
                transform="translate(-265.552 -194.401)"
                fill={theme.body}
              />
              <circle
                cx="8.52"
                cy="8.52"
                r="8.52"
                transform="translate(79.898 45.06)"
                fill={theme.dark}
              />
              <path
                d="M-.436,0C1.55,0,7.728,1.611,7.728,3.6s-6.177,3.6-8.164,3.6-6.056-1.61-6.056-3.6S-2.423,0-.436,0Z"
                transform="translate(88.855 97.315)"
                fill={theme.body}
              />
              <path
                d="M592.9,327.893,583.266,319a.37.37,0,0,0-.5,0l-4.4,4.067v-1.8a.37.37,0,0,0-.37-.37h-.74a.37.37,0,0,0-.37.37v3.171l-3.746,3.459a.37.37,0,0,0,.251.642h1.854a.37.37,0,0,1,.37.37v9.022a.37.37,0,0,0,.37.37H590.05a.37.37,0,0,0,.37-.37V328.9a.37.37,0,0,1,.37-.37h1.858a.37.37,0,0,0,.251-.642Zm-11.955,3.892h4.143a.37.37,0,0,1,.37.37v5.4h-4.883v-5.4a.37.37,0,0,1,.37-.37Z"
                transform="translate(-435.47 -265.324)"
                fill={theme.imageHighlight}
              />
            </g>
            <g transform="translate(255.461 80.587)">
              <path
                d="M8,0h97.321a8,8,0,0,1,8,8v2a8,8,0,0,1-8,8H8a8,8,0,0,1-8-8V8A8,8,0,0,1,8,0Z"
                transform="translate(0 12.747)"
                fill={theme.imageHighlight}
              />
              <path
                d="M5.666,0H125.432a5.666,5.666,0,1,1,0,11.332H5.666A5.666,5.666,0,0,1,5.666,0Z"
                transform="translate(0 41.246)"
                fill={theme.dark}
              />
              <path
                d="M5.666,0H125.432a5.666,5.666,0,1,1,0,11.332H5.666A5.666,5.666,0,0,1,5.666,0Z"
                transform="translate(0 63.077)"
                fill={theme.dark}
              />
            </g>
          </g>
        </g>
      </svg>
    );
  }
}
